export function getPermissions() {
  const userData = JSON.parse(localStorage.getItem(`${process.env.VUE_APP_NAME}_user`))

  if (!userData || userData.permissions == undefined) return []

  return userData.permissions
}

export function getOptionByPermission(field) {
  let permissions = getPermissions()
  if (field.type != 400) return field.options
  let fieldId = field.id
  let options = field.options.filter(item =>
    permissions.includes("option_" + fieldId + "_" + item.value),
  )
  if (options.length > 0) return options

  return field.options
}

export function getLayoutByPermission(layouts) {
  let permissions = getPermissions()

  let result = layouts.filter(item =>
    permissions.includes("layout_" + item.id),
  )
  if (result.length > 0) return result

  return layouts
}

export function getLayoutPermission(){
  let permissions = getPermissions()
  
  return permissions.filter(item=> item.includes("layout_"))
}

export function checkLayoutPermission(type, layoutId){
  let permissions = getPermissions()

  return permissions.some(item=> item === `layout_${type}_${layoutId}`)
}

export function checkPagePermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("page_" + pageName)
}

export function checkViewPermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("view_" + pageName)
}

export function checkCreatePermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("create_" + pageName)
}

export function checkEditPermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("edit_" + pageName)
}

export function checkDeletePermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("delete_" + pageName)
}

export function checkResetPasswordPermission(pageName) {
  let permissions = getPermissions()

  return permissions.includes("reset_" + pageName)
}


export function checkTransitionPermission(layoutId, transitionId) {
  let permissions = getPermissions()

  return permissions.includes(
    "transition_".concat(layoutId, "_", transitionId),
  )
}
